import { ActionTemplate } from 'apprise-core/action'
import { Lifecycled, Multilang, Note, Revisioned } from 'apprise-core/common'
import { Language } from 'apprise-core/language'
import { UserReference } from 'apprise-core/user'


export type TenantLifecycleState = "active" | "inactive"

export type BaseTenant = TenantDto

export type Tenant = BaseTenant & Partial<Revisioned<BaseTenant>>

export type TenantDto = Lifecycled<TenantLifecycleState> & {

  id: string,
  code?: string,
  name: Multilang
  guarded: boolean
  description: Multilang
  tags: string[]
  preferences: TenantPreferences
}

export type TenantRef = {

    id: string
    name: Multilang,
    description: Multilang
    code: string
  
}
export type TenantReference = string

export type TenantPreferences = Partial<{

  language: Language,
  location: string
  note: Note
  focalPoint: UserReference

}> & { [key: string]: any }    // extensible by client modules.


// the type of domain objects that are in the scope of a tenant.
export type TenantResource = {

  tenant: TenantReference

}

export const noTenant = "*"

export const hasTenant = (obj: any): obj is TenantResource => {
  return obj.tenant
}


export const unknownTenantId = 'unknown'

export const tenantPrefix = 'TNT'

export const tenantLifecycleTopic = 'tenant'


export const tenantType = 'tenant'

export const manageTenant: ActionTemplate = { type: tenantType, labels: ["manage"] }
export const editTenant: ActionTemplate = { type: tenantType, labels: ["manage","edit"] }
export const adminUsers: ActionTemplate = { type: tenantType, labels: ["manage","user"] }